export default __webpack_public_path__ + "static/media/rr_coins_account.8205831e.svg";